import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import Courses from './pages/Courses';
import Chat from './pages/Chat';
import Profile from './pages/Profile';
import QuickHelp from './pages/QuickHelp';
import TopicDetail from './pages/TopicDetail';
import AudioPracticeDetail from './pages/AudioPracticeDetail';
import CourseDetail from './pages/CourseDetail';
import { theme } from './styles';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:id" element={<CourseDetail />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/quick-help/:state?" element={<QuickHelp />} />
            <Route path="/topics/:slug" element={<TopicDetail />} />
            <Route path="/audio-practices/:id" element={<AudioPracticeDetail />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App; 